<script setup>
import { ref, computed, watch } from 'vue';
import { DatePicker } from 'view-design';

const props = defineProps({
    data: Array,
    loading: Boolean
});

const isTableGrouped = ref(true)
const dateRange = ref([]) // [startDate, endDate]

const userGroupSelected = ref(false)
const companyGroupSelected = ref(true)


// Definição das colunas (padrão)
const colls = ref([
    { label: 'ID Empresa', key: 'id_empresa', order: 'asc', sortable: true },
    { label: 'Empresa', key: 'nome_empresa', order: 'asc', sortable: true },
    { label: 'Email', key: 'email_visitante', order: 'asc', sortable: true },
    { label: 'Nome', key: 'nome_visitante', order: 'asc', sortable: true },
    { 
        label: 'Data', 
        key: 'created_at', 
        order: 'asc', 
        sortable: true,
        render: (h, params) => {
            const date = new Date(params.row.created_at);
            return h('p', [h('p', [`${date.toLocaleDateString('pt-BR')}`])]);
        }
    }
]);

const switchGroups = (user = false) => {
    // verifica se está alterando
    let isChanging = (userGroupSelected.value && !user) ||  (companyGroupSelected.value && user)

    userGroupSelected.value = user
    companyGroupSelected.value = !user

    if (isChanging) isTableGrouped.value = true
};

// Agrupa os registros por empresa ou usuário
const groupedTable = computed(() => {
    if (!props.data || props.data.length === 0) return [];

    const groups = props.data.reduce((acc, item) => {
        // Escolhe a chave do agrupamento
        const key = userGroupSelected.value ? item.email_visitante : item.id_empresa

        if (!acc[key]) {
            acc[key] = {
                id_empresa: item.id_empresa,
                nome_empresa: item.nome_empresa,
                email_visitante: item.email_visitante,
                total_chats: 0,
                primeira_data: new Date(item.created_at),
                ultima_data: new Date(item.created_at)
            };
        }

        acc[key].total_chats += 1;

        // Atualiza datas mínima e máxima
        if (new Date(item.created_at) < acc[key].primeira_data) acc[key].primeira_data = new Date(item.created_at);
        if (new Date(item.created_at) > acc[key].ultima_data) acc[key].ultima_data = new Date(item.created_at);

        return acc;
    }, {});

    // Formata datas para exibição
    return Object.values(groups).map(g => ({
        ...g,
        primeira_data: g.primeira_data.toLocaleDateString('pt-BR'),
        ultima_data: g.ultima_data.toLocaleDateString('pt-BR')
    }));
});

// Colunas alternativas para a tabela agrupada
const groupedCols = ref([
    { label: 'ID Empresa', key: 'id_empresa', sortable: true },
    { label: 'Nome', key: 'nome_empresa', sortable: true },
    { label: 'Total de Chats', key: 'total_chats', sortable: true },
    { label: 'Último Chat', key: 'primeira_data' }
]);

const emit = defineEmits(['update:dateRange']);

watch(dateRange, (newRange) => {
    console.log(newRange)

    emit('update:dateRange', newRange);
});
</script>

<template>
    <div>
        <div class="mb-3" style="display:flex; justify-content: space-between; align-items:center;">
            <div style="gap: 10px; display: flex;">
                <vs-button :color="companyGroupSelected ? 'primary' : 'gray'" @click="isTableGrouped = !isTableGrouped; switchGroups(false)">
                    {{ 
                        companyGroupSelected ? 
                            (isTableGrouped ? 'Lista completa' : 'Empresas agrupadas') 
                            : 'Empresas agrupadas' 
                    }}
                </vs-button>

                <vs-button :color="userGroupSelected ? 'primary' : 'gray'" @click="isTableGrouped = !isTableGrouped; switchGroups(true)">
                    {{ 
                        userGroupSelected ? 
                            (isTableGrouped ? 'Lista completa' : 'Usuários agrupados') 
                            : 'Usuários agrupados' 
                    }}
                </vs-button>
            </div>

            <!-- Date Range Picker iView -->
            <date-picker
                v-model="dateRange"
                type="daterange"
                format="dd/MM/yyyy"
                placeholder="Selecione o período"
                style="min-width:250px;"
                :transfer="true"
            />
        </div>

        <vx-table
            :columns="isTableGrouped ? groupedCols : colls"
            :data="isTableGrouped ? groupedTable : data"
            :loading="loading"
        />
    </div>
</template>
